"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ar_viewer_1 = __importDefault(require("./ar-viewer"));
class QuicklookViewer extends ar_viewer_1.default {
    constructor() {
        super();
        this.araction = null;
        this.titleHTML = "&checkoutTitle=" + document.title + "&checkoutSubtitle=" + document.title;
        this.arcallback = () => { };
    }
    get nodeType() {
        return "Quick Look";
    }
    get device() {
        return "ios";
    }
    start() {
        if (!this.modelUrl) {
            throw new Error("QuicklookViewer.start() - model url not set, use QuicklookViewer.modelUrl");
        }
        const anchor = document.createElement("a");
        anchor.setAttribute("rel", "ar");
        anchor.appendChild(document.createElement("img"));
        let url = this.modelUrl;
        const araction = this.araction;
        if (araction) {
            const handleQuicklook = (event) => {
                if (event.data === "_apple_ar_quicklook_button_tapped") {
                    this.arcallback();
                }
                document.body.removeChild(anchor);
                anchor.removeEventListener("message", handleQuicklook, false);
            };
            anchor.addEventListener("message", handleQuicklook, false);
            document.body.appendChild(anchor);
            url += "#callToAction=" + araction;
            if (this.titleHTML) {
                url += this.titleHTML;
            }
        }
        anchor.setAttribute("href", encodeURI(url));
        anchor.click();
    }
}
exports.default = QuicklookViewer;
